/**
 * A `value` prop to spread into a component whose typings omit null although the value may be
 * null (NumberFormat clears its input for null but keeps the typed text for undefined; rc-slider
 * and PhoneInput take a given value apart from undefined too), so null cannot become undefined.
 * TypeScript checks no named prop against a spread with an index signature only.
 */
const valueProp = <TValue>(value: TValue): Record<string, TValue> => ({ value });

export default valueProp;
